import gsap from "gsap/all"
import usefull from "./useful";

export default class Parrallax {
    constructor(el, ratio) {
        this.DOM = el;
        this.ratio = ratio === undefined ? 1 : ratio

        
        // Si Desktop -> on active l'effet parrallax 
        !usefull.isMobile() && this.parralax()
    }

    parralax() {
        gsap.set(this.DOM, {
            yPercent : -this.ratio * 2
        })
        gsap.to(this.DOM, {
            yPercent: this.ratio * 4,
            ease: "none",
            delay: 1,
            scrollTrigger: {
                trigger: this.DOM,
                scrub: true
            }
        });
    }
}